// Genera una imagen recortada (canvas) a partir del área devuelta por react-easy-crop.
// Devuelve un File JPEG listo para subir, con `.preview` (objectURL) para previsualizar.

export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

const getCroppedImg = async (imageSrc, pixelCrop, fileName = 'avatar.jpg') => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = Math.max(1, Math.round(pixelCrop.width));
  canvas.height = Math.max(1, Math.round(pixelCrop.height));

  // Al permitir zoom-out (recorte más amplio que la imagen), el área puede exceder los límites
  // de la foto; rellenamos con off-black para que las bandas del letterbox queden limpias en JPEG
  // (sin alpha). Para recortes que cubren todo el lienzo (avatar/plan) el relleno no se ve.
  ctx.fillStyle = '#0A0A0A';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        const file = new File([blob], fileName, { type: 'image/jpeg' });
        file.preview = URL.createObjectURL(blob);
        resolve(file);
      },
      'image/jpeg',
      0.92
    );
  });
};

/**
 * Parte una foto APAISADA por la mitad vertical y devuelve [izquierda, derecha].
 *
 * Sirve para las fotos que traen las DOS poses del stop-motion en una sola toma: en vez de
 * pedir dos archivos, se corta aquí y cada mitad se encuadra después (el recorte fino sigue
 * siendo del admin, esto solo automatiza la tijera).
 *
 * `gutter` es la fracción del ancho de cada mitad que se descarta en la costura central,
 * útil cuando las dos poses casi se tocan y el borde de una se cuela en la otra.
 */
export const splitDiptych = async (imageSrc, { gutter = 0 } = {}) => {
  const image = await createImage(imageSrc);
  const width = image.naturalWidth || image.width;
  const height = image.naturalHeight || image.height;

  const half = Math.floor(width / 2);
  const inset = Math.round(half * Math.min(0.4, Math.max(0, gutter)));
  const halfWidth = Math.max(1, half - inset);

  const left = await getCroppedImg(imageSrc, { x: 0, y: 0, width: halfWidth, height }, 'frame-1.jpg');
  const right = await getCroppedImg(imageSrc, { x: width - halfWidth, y: 0, width: halfWidth, height }, 'frame-2.jpg');

  return [left, right];
};

export default getCroppedImg;
